module.exports = __webpack_public_path__ + "static/media/3.b124e235.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/3.mp3
// module id = 54
// module chunks = 0